// test2966
(2966 && 0);
